// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/mukta/Mukta-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/mukta/Mukta-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/mukta/Mukta-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/mukta/Mukta-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/mukta/Mukta-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/mukta/Mukta-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary: #13add5;
  --secondary: #75dd02;
  --scroll-color: rgba(0, 0, 0, 0.6);
  --scroll-background: #f9f9f9;
}

@font-face {
  font-family: Mukta-Bold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype");
}
@font-face {
  font-family: Mukta-ExtraBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("opentype");
}
@font-face {
  font-family: Mukta-ExtraLight;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype");
}
@font-face {
  font-family: Mukta-Light;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("opentype");
}
@font-face {
  font-family: Mukta-Medium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("opentype");
}
@font-face {
  font-family: Mukta-Regular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("opentype");
}
@font-face {
  font-family: Mukta-SemiBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("opentype");
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  color: #414042 !important;
  background-color: #f5f5f5 !important;
  font-family: Mukta-Medium !important;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background: var(--scroll-background);
}

::-webkit-scrollbar-track {
  box-shadow: inset 0 0 3px rgb(197, 197, 197);
  border-radius: 5px;
}

::-webkit-scrollbar-thumb {
  background: var(--scroll-color);
  border-radius: 5px;
}

.main-container-layout {
  margin-top: 64px;
  height: calc(100vh - 64px);
  overflow: auto;
}

@media screen and (min-width: 426px) and (max-width: 899px) {
  .profile-name {
    display: block !important;
  }
}
.slick-arrow {
  background-color: black !important;
}

.slick-next {
  right: 10px;
}

.slick-prev {
  left: 10px;
}

.slider-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.slick-arrow {
  display: block;
  background-color: #000;
  color: #fff;
  border-radius: 50%;
  line-height: 40px;
  text-align: center;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
}

.slick-slide {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.slick-track {
  justify-content: center !important;
  align-items: center !important;
  display: flex !important;
}

.css-ypiqx9-MuiDialogContent-root {
  padding: 20px 37px !important;
}

.bg-13add5 {
  background-color: #13add5 !important;
}

.text-white {
  color: #fff !important;
}

.d-flex {
  display: flex !important;
}

.justify-center {
  justify-content: center !important;
}

.fw-700 {
  font-weight: 600 !important;
}

.mt-20 {
  margin-top: 20px;
}

iframe#webpack-dev-server-client-overlay {
  display: none;
}

.justify-right {
  justify-content: right !important;
}

.badge {
  padding: 0 0.5rem;
  border-radius: 5px;
  width: -moz-fit-content;
  width: fit-content;
}

.pending-badge {
  background-color: grey !important;
  color: white !important;
}

.waiting-badge {
  background-color: orange !important;
  color: white !important;
}

.reassign-badge {
  background-color: pink !important;
  color: white !important;
}

.approved-badge {
  background-color: green !important;
  color: white !important;
}

.declined-badge {
  background-color: red !important;
  color: white !important;
}

.box-indicator {
  width: 20px;
  height: 20px;
  display: inline-block;
  border-radius: 5px;
  margin: 0 0.5rem 0 0;
}

.box-content {
  display: flex;
  font-style: italic;
  margin: 0 1rem 0 0;
}
.box-content p {
  margin-top: -0.1rem;
}

.PdfPage {
  position: relative;
  margin: auto;
}
.PdfPage__textLayer {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  opacity: 0.2;
  line-height: 1;
}
.PdfPage span {
  color: transparent;
  position: absolute;
  white-space: pre;
  cursor: text;
  transform-origin: 0% 0%;
  font-size: 10px;
}

.ReactVirtualized__Grid__innerScrollContainer > div {
  padding-bottom: 1rem;
  background-color: #f9f9f9;
}

.react-pdf__Page {
  background-color: #f9f9f9;
  padding: 1.375rem 0;
}

.pdf-viewer {
  height: 80vh;
}
.pdf-viewer .react-pdf__Page__canvas {
  width: 100% !important;
  height: 100% !important;
}

.react-pdf__Page__canvas {
  margin: 0 auto;
}

.react-pdf__message--loading {
  display: none !important;
}

@media screen and (max-width: 600px) {
  .react-pdf__Page__canvas {
    width: 100% !important;
  }
}
.clear_pdf .react-pdf__Page {
  background-color: rgba(0, 0, 0, 0);
}`, "",{"version":3,"sources":["webpack://./src/assets/css/style.scss","webpack://./src/assets/css/sidebar.scss","webpack://./src/assets/css/carousal.scss","webpack://./src/assets/css/custom.scss","webpack://./src/assets/css/pdfViewer.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,oBAAA;EACA,kCAAA;EACA,4BAAA;AACF;;AAEA;EACE,uBAAA;EACA,+DAAA;AACF;AACA;EACE,4BAAA;EACA,+DAAA;AACF;AACA;EACE,6BAAA;EACA,+DAAA;AACF;AACA;EACE,wBAAA;EACA,+DAAA;AACF;AACA;EACE,yBAAA;EACA,+DAAA;AACF;AACA;EACE,0BAAA;EACA,+DAAA;AACF;AACA;EACE,2BAAA;EACA,+DAAA;AACF;AAEA;EACE,SAAA;EACA,UAAA;EACA,sBAAA;AAAF;;AAGA;EACE,yBAAA;EACA,oCAAA;EACA,oCAAA;AAAF;;AAGA;EACE,UAAA;EACA,WAAA;EACA,oCAAA;AAAF;;AAGA;EACE,4CAAA;EACA,kBAAA;AAAF;;AAGA;EACE,+BAAA;EACA,kBAAA;AAAF;;AC7DA;EACE,gBAAA;EACA,0BAAA;EACA,cAAA;ADgEF;;AC7DA;EACE;IACE,yBAAA;EDgEF;AACF;AEzEA;EACE,kCAAA;AF2EF;;AExEA;EACE,WAAA;AF2EF;;AExEA;EACE,UAAA;AF2EF;;AExEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AF2EF;;AExEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AF2EF;;AExEA;EACE,cAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;AF2EF;;AExEA;EACE,wBAAA;EACA,kCAAA;EACA,8BAAA;AF2EF;;AExEA;EACE,kCAAA;EACA,8BAAA;EACA,wBAAA;AF2EF;;AExEA;EACE,6BAAA;AF2EF;;AExEA;EACE,oCAAA;AF2EF;;AExEA;EACE,sBAAA;AF2EF;;AExEA;EACE,wBAAA;AF2EF;;AExEA;EACE,kCAAA;AF2EF;;AExEA;EACE,2BAAA;AF2EF;;AExEA;EACE,gBAAA;AF2EF;;AGtJA;EACE,aAAA;AHyJF;;AGtJA;EACE,iCAAA;AHyJF;;AGtJA;EACE,iBAAA;EACA,kBAAA;EACA,uBAAA;EAAA,kBAAA;AHyJF;;AGtJA;EACE,iCAAA;EACA,uBAAA;AHyJF;;AGtJA;EACE,mCAAA;EACA,uBAAA;AHyJF;;AGtJA;EACE,iCAAA;EACA,uBAAA;AHyJF;;AGtJA;EACE,kCAAA;EACA,uBAAA;AHyJF;;AGtJA;EACE,gCAAA;EACA,uBAAA;AHyJF;;AGtJA;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,oBAAA;AHyJF;;AGtJA;EACE,aAAA;EACA,kBAAA;EACA,kBAAA;AHyJF;AGvJE;EACE,mBAAA;AHyJJ;;AI9MA;EACE,kBAAA;EACA,YAAA;AJiNF;AI/ME;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;AJiNJ;AI9ME;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;AJgNJ;;AI5MA;EACE,oBAAA;EACA,yBAAA;AJ+MF;;AI5MA;EACE,yBAAA;EACA,mBAAA;AJ+MF;;AI5MA;EACE,YAAA;AJ+MF;AI7ME;EACE,sBAAA;EACA,uBAAA;AJ+MJ;;AI3MA;EACE,cAAA;AJ8MF;;AI3MA;EACE,wBAAA;AJ8MF;;AI3MA;EACE;IACE,sBAAA;EJ8MF;AACF;AI3MA;EACE,kCAAA;AJ6MF","sourcesContent":[":root {\n  --primary: #13add5;\n  --secondary: #75dd02;\n  --scroll-color: rgba(0, 0, 0, 0.6);\n  --scroll-background: #f9f9f9;\n}\n\n@font-face {\n  font-family: Mukta-Bold;\n  src: url(\"../fonts/mukta/Mukta-Bold.ttf\") format(\"opentype\");\n}\n@font-face {\n  font-family: Mukta-ExtraBold;\n  src: url(\"../fonts/mukta/Mukta-ExtraBold.ttf\") format(\"opentype\");\n}\n@font-face {\n  font-family: Mukta-ExtraLight;\n  src: url(\"../fonts/mukta/Mukta-Bold.ttf\") format(\"opentype\");\n}\n@font-face {\n  font-family: Mukta-Light;\n  src: url(\"../fonts/mukta/Mukta-Light.ttf\") format(\"opentype\");\n}\n@font-face {\n  font-family: Mukta-Medium;\n  src: url(\"../fonts/mukta/Mukta-Medium.ttf\") format(\"opentype\");\n}\n@font-face {\n  font-family: Mukta-Regular;\n  src: url(\"../fonts/mukta/Mukta-Regular.ttf\") format(\"opentype\");\n}\n@font-face {\n  font-family: Mukta-SemiBold;\n  src: url(\"../fonts/mukta/Mukta-SemiBold.ttf\") format(\"opentype\");\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  color: #414042 !important;\n  background-color: #f5f5f5 !important;\n  font-family: Mukta-Medium !important;\n}\n\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n  background: var(--scroll-background);\n}\n\n::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 3px rgb(197, 197, 197);\n  border-radius: 5px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--scroll-color);\n  border-radius: 5px;\n}\n\n@import \"./sidebar.scss\";\n@import \"./carousal.scss\";\n@import \"./custom.scss\";\n@import \"./pdfViewer.scss\";\n",".main-container-layout {\n  margin-top: 64px;\n  height: calc(100vh - 64px);\n  overflow: auto;\n}\n\n@media screen and (min-width: 426px) and (max-width: 899px) {\n  .profile-name {\n    display: block !important;\n  }\n}\n",".slick-arrow {\n  background-color: black !important;\n}\n\n.slick-next {\n  right: 10px;\n}\n\n.slick-prev {\n  left: 10px;\n}\n\n.slider-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.image-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n\n.slick-arrow {\n  display: block;\n  background-color: #000;\n  color: #fff;\n  border-radius: 50%;\n  line-height: 40px;\n  text-align: center;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 1;\n}\n\n.slick-slide {\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n}\n\n.slick-track {\n  justify-content: center !important;\n  align-items: center !important;\n  display: flex !important;\n}\n\n.css-ypiqx9-MuiDialogContent-root {\n  padding: 20px 37px !important;\n}\n\n.bg-13add5 {\n  background-color: #13add5 !important;\n}\n\n.text-white {\n  color: #fff !important;\n}\n\n.d-flex {\n  display: flex !important;\n}\n\n.justify-center {\n  justify-content: center !important;\n}\n\n.fw-700 {\n  font-weight: 600 !important;\n}\n\n.mt-20 {\n  margin-top: 20px;\n}\n","iframe#webpack-dev-server-client-overlay {\n  display: none;\n}\n\n.justify-right {\n  justify-content: right !important;\n}\n\n.badge {\n  padding: 0 0.5rem;\n  border-radius: 5px;\n  width: fit-content;\n}\n\n.pending-badge {\n  background-color: grey !important;\n  color: white !important;\n}\n\n.waiting-badge {\n  background-color: orange !important;\n  color: white !important;\n}\n\n.reassign-badge {\n  background-color: pink !important;\n  color: white !important;\n}\n\n.approved-badge {\n  background-color: green !important;\n  color: white !important;\n}\n\n.declined-badge {\n  background-color: red !important;\n  color: white !important;\n}\n\n.box-indicator {\n  width: 20px;\n  height: 20px;\n  display: inline-block;\n  border-radius: 5px;\n  margin: 0 0.5rem 0 0;\n}\n\n.box-content {\n  display: flex;\n  font-style: italic;\n  margin: 0 1rem 0 0;\n\n  p {\n    margin-top: -0.1rem;\n  }\n}\n",".PdfPage {\n  position: relative;\n  margin: auto;\n\n  &__textLayer {\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    overflow: hidden;\n    opacity: 0.2;\n    line-height: 1;\n  }\n\n  span {\n    color: transparent;\n    position: absolute;\n    white-space: pre;\n    cursor: text;\n    transform-origin: 0% 0%;\n    font-size: 10px;\n  }\n}\n\n.ReactVirtualized__Grid__innerScrollContainer > div {\n  padding-bottom: 1rem;\n  background-color: #f9f9f9;\n}\n\n.react-pdf__Page {\n  background-color: #f9f9f9;\n  padding: 1.375rem 0;\n}\n\n.pdf-viewer {\n  height: 80vh;\n\n  .react-pdf__Page__canvas {\n    width: 100% !important;\n    height: 100% !important;\n  }\n}\n\n.react-pdf__Page__canvas {\n  margin: 0 auto;\n}\n\n.react-pdf__message--loading {\n  display: none !important;\n}\n\n@media screen and (max-width: 600px) {\n  .react-pdf__Page__canvas {\n    width: 100% !important;\n  }\n}\n\n.clear_pdf .react-pdf__Page {\n  background-color: #00000000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
